import React from 'react'
import BasePage from "Base/Page"
class Work extends BasePage {
    constructor(props) {
        super(props)
        document.title = document.title + " - work"
    }

    render() {
        return (
<div className="main_container">
<div className="card fluid">

    <h2>Perl</h2>
    <div className="section">I have put all of them under the namespace Zug:: because there are enough
    vanity module distributions taking up good names on CPAN. Even so I do not have plans
     to release them on CPAN any time soon since all of them fill a very narrow
     need and there are better and more general modules to use.
    </div>

    <div className="section">
       <h3><a href="https://bitbucket.org/emilper/zug-xlsx-huge">Zug::XLSX::Huge</a></h3>
       build very simple but very large xlsx files without running out of RAM
    </div>

    <div className="section">
       <h3><a href="https://bitbucket.org/emilper/zug-monitor">Zug::Monitor</a></h3>
    Zug::Monitor::watch will take a coderef and it will execute it in a forked
    process and watch the size of the forked process. A soft limit and a hard
    limit should be provided: when each of them is crossed the corresponding
    callback is executed. You can provide a grace_count, that is how many iterations
    of the watcher can the child fork survive after crossing the hard limit.
    </div>

    <div className="section">
       <h3><a href="https://bitbucket.org/emilper/zug-simplezip">Zug::SimpleZip</a></h3>
    Working but no advantage of speed over Archive::ZIP.
    </div>

    <h2>Node/Javascript</h2>
    <div className="section">
    From time to time I am taking code out of a personal private project and
    making it available, mostly to force myself keep it modular. All modules should
    use <a href="https://www.npmjs.com/package/tap">TAP</a> for testing; if not
    then it is a bug :-).
    </div>

    <div className="section">
        <h3><a href="https://bitbucket.org/emilper/matrix-mab">matrix-mab</a></h3>
        <p>node/browser module for manipulating 2d matrices</p>
        <p>early stage of development but what works is available on npm as 
        "matrix-mab"</p>
    </div>

    <div className="section">
        <h3><a href="https://bitbucket.org/emilper/haphazard">haphazard</a></h3>
        <p> some seedable pseudorandom number generators either implemented from
        scratch in node or
        wrapped in a class to offer a consistent interface</p>
    </div>

    <div className="section">
        <h3><a href="https://bitbucket.org/emilper/nary-tree-mab">nary-tree-mab</a></h3>
        <p>not really a n-ary tree, but from outside it looks like one and it
        can be walked as if it were one</p>
        <p>inside it is just a Map, a few ints and a closure</p>
    </div>


    <h2>Dlang</h2>
    <div className="section">
        <h3><a href="https://bitbucket.org/emilper/zug-matrix">zug-matrix</a></h3>
        <p>not finished; code for manipulating generic matrices</p>
    </div>
    <div className="section">
        <h3><a href="https://bitbucket.org/emilper/zugdbi">zugdbi</a></h3>
        <p>basic DB api for Dlang inspired by the Perl DBI</p>
    </div>
</div>
</div>
        )
    }
}

export default Work



// WEBPACK FOOTER //
// ./src/lib/components/site/pages/Work.js